var contentDescriptionFields = ['id', 'label', 'editable', 'visible'];
var fromOptionsToContentSelection = function (options) {
    if (options === void 0) { options = []; }
    var contentSelection = [];
    options.forEach(function (option) {
        if (option.visible) {
            contentSelection.push(option.id);
        }
    });
    return contentSelection;
};
export var fromOptionsGroupsToContentSelection = function (optionsGroups) {
    var contentSelection = [];
    optionsGroups.forEach(function (group) {
        contentSelection.push.apply(contentSelection, fromOptionsToContentSelection(group.options));
    });
    return contentSelection;
};
var copyOptions = function (options) {
    if (options === void 0) { options = []; }
    return options.map(function (option) {
        var newOption = {};
        contentDescriptionFields.forEach(function (key) {
            newOption[key] = option[key];
        });
        return newOption;
    });
};
export var copyOptionsGroups = function (optionsGroups) {
    return optionsGroups.map(function (group) {
        var newGroup = {};
        newGroup.label = group.label;
        newGroup.options = copyOptions(group.options);
        return newGroup;
    });
};
function isOneMissing(a, b) {
    return Boolean(a) !== Boolean(b);
}
function compareOptions(option1, option2) {
    if (option1 === option2)
        return true;
    if (isOneMissing(option1, option1))
        return false;
    return contentDescriptionFields.every(function (key) { return option1[key] === option2[key]; });
}
function compareSingleOptionGroups(group1, group2) {
    if (group1 === group2)
        return true;
    if (isOneMissing(group1, group2))
        return false;
    if (group1.options.length !== group2.options.length)
        return false;
    if (group1.label !== group2.label)
        return false;
    return group1.options.every(function (option, index) { return compareOptions(option, group2.options[index]); });
}
export function compareOptionGroups(groups1, groups2) {
    if (groups1 === groups2)
        return true;
    if (isOneMissing(groups1, groups2))
        return false;
    if (groups1.length !== groups2.length)
        return false;
    return groups1.every(function (optionsGroup, index) { return compareSingleOptionGroups(optionsGroup, groups2[index]); });
}
//# sourceMappingURL=utils.js.map